export default function(options) {
	if (!window.tinymce) {
		return
	}

	const tinymce = window.tinymce

	let setup = {
		selector: options.selector,
		language: document.querySelector('html').getAttribute('lang'),
		menubar: false,
		plugins: 'link code fullscreen', // powerpaste
		content_css: window.location.origin + '/assets/dist/css/tinymce.css',
		advlist_bullet_styles: 'square',
		advlist_number_styles: 'default',
		height: options.height,
		statusbar: false,
		resize: false,
		browser_spellcheck: true,
		relative_urls : false,
		remove_script_host : false,
		document_base_url : new URL(window.location.href).origin,
		setup: (editor) => {
			editor.on('keyup', (e) => {
				window.tinymce.triggerSave()

				const input = document.querySelector(options.selector)
				const parent = input?.parentElement
				const helper = parent?.querySelector('.tinymce-helper')
				if (helper) {
					helper.innerHTML = window.tinymce.activeEditor?.getContent()
				}
			})

			editor.on('init', (e) => {
				e.target.targetElm.classList.add('tinymce-initiated')

				const parent = e.target.targetElm.parentElement
				parent.querySelector('.editor-loader')?.classList.add('d-none')
				parent.querySelector('.tinymce-helper')?.classList.add('d-none')

				if (options.autofocus) {
					editor.focus()
				}

				if (e.target.targetElm.dataset.onInitHide === "true") {
					window.tinymce.get(e.target.targetElm.getAttribute('id')).hide()
				}
			})

			editor.on('detach', (e) => {
				const input = e.target.targetElm
				const parent = input.parentElement
				const helper = parent.querySelector('.tinymce-helper')

				input.classList.add('d-none')

				if (helper) {
					helper.classList.add('d-none')
					if (helper.textContent === '') {
						input.classList.remove('d-none')
					} else {
						helper.classList.remove('d-none')
					}
				}
			})

			editor.on('focus', (e) => {
				const input = document.querySelector(options.selector)
				if (input) {
					input.classList.add('d-none')

					const parent = input.parentElement
					const helper = parent.querySelector('.tinymce-helper')
					helper?.classList.add('d-none')
				}
			})

			editor.on('blur', (e) => {
				window.tinymce.triggerSave()

				const input = document.querySelector(options.selector)
				const parent = input?.parentElement
				const helper = parent?.querySelector('.tinymce-helper')

				if (helper) {
					const editor = window.tinymce.get(e.target.targetElm.getAttribute('id'))
					if (editor) {
						if (editor.getContent({format: 'text'}) === '') {
							input.classList.remove('d-none')
						} else {
							helper.classList.remove('d-none')
						}

						editor.hide()
					}
				}
			})
		}
	}

	if (options.toolbar === false) {
		setup.toolbar = false
	} else {
		setup.toolbar = 'undo redo paste removeformat fullscreen | blocks fontsize | bold italic underline strikethrough | align lineheight | checklist numlist bullist indent outdent | link unlink | forecolor backcolor | table | code'
	}

	tinymce.init(setup)
}
